<template>
    <div class="Man-JbRequisicaoPrincipal">
        <PageTitle icon="fa fa-gear" main="Requisição"
            sub="Estoque Requisições" />
        <div class="Man-JbRequisicaoPrincipal">
            <b-card no-body>
                <b-tabs>                                        
                    <b-tab title="Requisição" active><JbSupSolicitacao /></b-tab>                                                                                                                        
                    <b-tab title="Fornecedores"><Fornecedores /></b-tab>     
                    <b-tab title="Indicadores" ><JbSupSolicitacaoPainel /></b-tab>                                                                                                                                           
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import JbSupSolicitacao from '../sambaiba/JbSupSolicitacao'
import JbSupSolicitacaoPainel from '../sambaiba/JbSupSolicitacaoPainel'
import Fornecedores from '../sambaiba/ClienteFornecedor'


export default {
    name: 'JbRequisicaoPrincipal',    
    components: { PageTitle, JbSupSolicitacao, JbSupSolicitacaoPainel,Fornecedores}
    
}
</script>

<style>

</style>






